export default "https://cdn-static.gokick.com/assets/d6a1d1f7abc93216fd07fb40adb7adf28904b072/images/choco-chill.f91442e53028d067e0a40cd80e4e8aae.png";